import classNames from "classnames";
import React from "react";
import "./TableClasses.scss";

const TableDataRow = (props: {
  children: any;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
}) => {
  const { children, className, onClick } = props;

  return (
    <tr
      className={classNames("table-data-row", className)}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {children}
    </tr>
  );
};

export default TableDataRow;
